import React, { Component } from 'react';
import * as enums from '../../../../../utils/EnumMapping';
import MainTable from '../../../../common/table/MainTable';
import NewRestrain from './NewRestrain';
import * as columns from './RestrainColumns';
import { tabs } from '../RestrainUtil';
import LinkTab from '../../../../common/tab/TabNav.js';

class Restrain extends Component {

    enrich = (data) => {
        data.map((item) => {
            item.rowType = "RESTRAIN";
            item.paymentMethodLabel = enums.getLabel(enums.outPaymentMethods, item.paymentMethod);
            item.stateLabel = enums.getLabel(enums.states, item.state);
            return item;
        })
        return data;
    }

    render() {
        return (
            <>
                <LinkTab tabs={tabs} index={0} />
                <MainTable
                    divClassName="restrain"
                    tableName="Letiltások"
                    newObjectLabel="Új letiltás hozzáadása"
                    path='/api/restrains'
                    enrich={this.enrich}
                    columns={(refresh) => columns.columns(refresh)}
                    dialogContent={(refresh, close) => <NewRestrain refresh={refresh} close={close} />} />
            </>
        );
    }
}

export default Restrain;